import {
  find,
  get,
  isPlainObject,
  trim,
  truncate,
  map,
  reduce,
  without,
  toString,
  isArray,
  isNumber,
  isBoolean,
  isString,
  keys,
  memoize
} from "lodash";
import flatten from "tree-flatten";
import stripTags from "string-strip-html";
import { store } from "../Store";

const getValue = memoize(
  ({ ref, value }) => {
    const db = get(store.getState(), "dbState", {});

    // const a = { a: "woot", children: [{ a: "dude" }] };
    // console.log(flatten(a, "children"));
    // if (ref) {
    // console.log(ref, db[ref]);
    // console.log(ref, db[ref], flatten(cloneDeep(db[ref]), "children"));
    // }
    // console.log(ref, value, get(store.getState(), `dbState.${ref}.${value}`));
    // return ref ? get(store.getState(), `dbState.${ref}.${value}`, value) : value;

    return ref
      ? get(
          db,
          `${ref}.${value}`,
          find(
            reduce(
              db[ref],
              (acc, item) => {
                const flat = flatten(item, "children");
                acc.push(...flat);
                return acc;
              },
              []
            ),
            { id: value }
          )
        )
      : value;
  },
  (ref, value) => `${JSON.stringify(ref)}-${JSON.stringify(value)}`
);

const shorten = (value, maxLength) =>
  truncate(trim(value), { length: maxLength, separator: "..." });

export const renderValues = memoize(
  ({
    value,
    properties,
    relation = {},
    stripHTML = true,
    joinWith = ", ",
    maxLength = Infinity
  }) => {
    if (isPlainObject(value)) {
      // console.log('OBJ', value, properties);
      return shorten(
        without(
          map(isArray(properties) ? properties : keys(properties), key => {
            if (get(properties, `${key}.hidden`)) {
              return null;
            }
            return renderValues({
              value: getValue({ ref: relation.ref, value: value[key] }),
              properties: get(properties, `${key}.${properties}`) ||
                get(properties, `${key}.relation.fields`, relation.fields) || {
                  name: "",
                  label: ""
                },
              relation: get(properties, `${key}.relation`, relation)
            });
          }),
          null,
          undefined,
          ""
        ).join(joinWith),
        maxLength
      );
    }

    if (isArray(value)) {
      return shorten(
        without(
          map(value, val =>
            renderValues({
              value: getValue({ ref: relation.ref, value: val }),
              properties: properties ||
                relation.fields || { name: "", label: "" }
            })
          ),
          null,
          undefined,
          ""
        ).join(joinWith),
        maxLength
      );
    }

    if (isString(value) || isNumber(value) || isBoolean(value)) {
      const val = getValue({ ref: relation.ref, value });
      if (isArray(val) || isPlainObject(val)) {
        return renderValues({
          value: val,
          properties: properties || relation.fields || { name: "", label: "" }
        });
      }
      return shorten(stripHTML ? stripTags(toString(val)) : val, maxLength);
    }

    return "";
  },
  (
    value,
    properties,
    relation = {},
    stripHTML = true,
    joinWith = ", ",
    maxLength = Infinity
  ) =>
    `${JSON.stringify(value)}-${JSON.stringify(properties)}-${JSON.stringify(
      relation
    )}-${JSON.stringify(stripHTML)}-${JSON.stringify(joinWith)}-${maxLength}`
);

export const collectionToArray = collection => {
  if (isArray(collection)) {
    return collection;
  }
  // console.log({ collection });
  return map(collection, (entry, id) => ({ ...entry, id }));
};
